import React from "react";
import { Link } from "react-router-dom";
import { Phone, MapPin, Clock, Sparkles } from "lucide-react";
import { site } from "../mock";
import { villesSEO } from "../villes";
import { servicesSeo } from "../servicesSeo";

export default function Footer() {
  return (
    <footer className="bg-jetblack border-t border-[rgba(212,168,56,0.3)] mt-20">
      <div className="container-narrow py-14 grid md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-2 mb-3">
            <Sparkles className="w-5 h-5 text-gold" />
            <span className="font-display text-lg gold-gradient-text">{site.name}</span>
          </div>
          <p className="text-sm text-gold-soft/95 leading-relaxed">
            Grand marabout africain à Orléans, Maître Diamma met sa lignée ancestrale et ses dons médiumniques au service de votre bonheur : retour de l'être aimé, magie blanche, désenvoûtement, lutte contre la sorcellerie, protection et voyance juste.
          </p>
        </div>

        <div>
          <h4 className="font-display text-gold mb-3 uppercase text-sm tracking-widest">Navigation</h4>
          <ul className="space-y-2 text-sm text-gold-soft/95">
            <li><Link to="/" className="hover:text-gold">Accueil</Link></li>
            <li><Link to="/retour-affectif" className="hover:text-gold">Retour affectif</Link></li>
            <li><Link to="/voyance" className="hover:text-gold">Voyance & Médiumnité</Link></li>
            <li><Link to="/guerisseur" className="hover:text-gold">Guérisseur traditionnel</Link></li>
            {servicesSeo.map((s) => (
              <li key={s.slug}><Link to={`/${s.slug}`} className="hover:text-gold">{s.h1}</Link></li>
            ))}
            <li><Link to="/blog" className="hover:text-gold">Villes desservies</Link></li>
            <li><Link to="/articles" className="hover:text-gold">Articles & conseils</Link></li>
            <li><Link to="/contact" className="hover:text-gold">Contact</Link></li>
            <li><Link to="/mentions-legales" className="hover:text-gold">Mentions légales</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display text-gold mb-3 uppercase text-sm tracking-widest">Orléans & Loiret</h4>
          <p className="text-sm text-gold-soft/95 leading-relaxed">
            {villesSEO.slice(0, 12).map((v) => v.nom).join(" • ")}…
          </p>
          <p className="text-xs text-gold-deep mt-2">Métropole • Loiret • Villes voisines</p>
          <Link to="/blog" className="text-xs text-gold hover:underline mt-2 inline-block">Voir toutes les villes →</Link>
        </div>

        <div>
          <h4 className="font-display text-gold mb-3 uppercase text-sm tracking-widest">Cabinet</h4>
          <ul className="space-y-3 text-sm text-gold-soft/95">
            <li className="flex items-start gap-2"><MapPin className="w-4 h-4 mt-0.5 text-gold" /><span>{site.address}</span></li>
            <li className="flex items-center gap-2"><Phone className="w-4 h-4 text-gold" /><a href={`tel:${site.phoneRaw}`} className="hover:text-gold">{site.phone}</a></li>
            <li className="flex items-center gap-2">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" className="text-gold" aria-hidden="true"><path d="M20.52 3.48A11.94 11.94 0 0 0 12.04 0C5.5 0 .2 5.3.2 11.83c0 2.08.55 4.11 1.6 5.9L0 24l6.44-1.69a11.83 11.83 0 0 0 5.6 1.42h.01c6.53 0 11.83-5.3 11.83-11.83 0-3.16-1.23-6.13-3.36-8.42z"/></svg>
              <a href={site.whatsapp} target="_blank" rel="noreferrer" className="hover:text-gold">WhatsApp direct</a>
            </li>
            <li className="flex items-center gap-2"><Clock className="w-4 h-4 text-gold" /><span>{site.hours}</span></li>
          </ul>
        </div>
      </div>

      {/* Keyword-rich SEO strip */}
      <div className="border-t border-[rgba(212,168,56,0.2)]">
        <div className="container-narrow py-8">
          <h4 className="font-display text-gold text-sm uppercase tracking-widest mb-3">Marabout à Orléans, dans le Loiret et alentours</h4>
          <div className="flex flex-wrap gap-x-3 gap-y-1 text-[11px] text-gold-soft/85">
            {villesSEO.map((v, i) => (
              <React.Fragment key={v.slug}>
                <Link data-testid={`footer-city-${v.slug}`} to={`/marabout/${v.slug}`} className="hover:text-gold">Marabout {v.nom}</Link>
                {i < villesSEO.length - 1 && <span>•</span>}
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>

      <div className="border-t border-[rgba(212,168,56,0.2)]">
        <div className="container-narrow py-5 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-xs text-gold-deep">© {new Date().getFullYear()} {site.name} — Marabout voyant à Orléans (45). Tous droits réservés.</p>
          <p className="text-xs text-gold-deep">Marabout • Sorcier puissant • Voyant • Médium • Désenvoûtement • Magie blanche • Retour affectif • Orléans</p>
        </div>
      </div>
    </footer>
  );
}
